import React from "react";
import "../../../Styles/components/form-controls.scss";

export default function FormSelect({
  className = "",
  disabled = false,
  error = "",
  label = "",
  onChange,
  options = [],
  prefix = null,
  value = "",
  ...props
}) {
  const hasPlaceholderValue = value === "" || value === null || value === undefined || value === "-1";

  return (
    <div className={["form-field", className].filter(Boolean).join(" ")}>
      {label ? <label className="form-field__label">{label}</label> : null}
      <div
        className={[
          "form-field__select-wrap",
          prefix ? "has-prefix" : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {prefix ? <span className="form-field__prefix">{prefix}</span> : null}
        <select
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={[
            "form-field__control",
            "form-field__select",
            hasPlaceholderValue ? "is-placeholder" : "",
            error ? "has-error" : "",
          ]
            .filter(Boolean)
            .join(" ")}
          {...props}
        >
          {options.map((option) => (
            <option key={option.key || option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <span className="form-field__select-arrow" aria-hidden="true" />
      </div>
      {error ? <div className="form-field__error">{error}</div> : null}
    </div>
  );
}
